import { useQuery } from '@tanstack/react-query';
import { getCurrentSeason, getSeasons } from '@/api/seasons';
import type { SeasonDto } from '@/types/season';

export function useSeasons(params: { limit?: number } = {}) {
  return useQuery({
    queryKey: ['seasons', 'list', params],
    queryFn: () => getSeasons({ order: 'start_year.desc', limit: params.limit ?? 20 }),
    staleTime: 5 * 60 * 1000,
  });
}

export function useCurrentSeason() {
  const query = useQuery<SeasonDto>({
    queryKey: ['season', 'current'],
    queryFn: getCurrentSeason,
    staleTime: 5 * 60 * 1000,
  });

  return query;
}
